import searchFill from '@iconify/icons-eva/search-fill';
import { Icon } from '@iconify/react';
// material
import { Box, FormControl, OutlinedInput, InputAdornment, ClickAwayListener } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Input } from 'src/@/components/ui/input';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

ChatContactSearch.propTypes = {
  query: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onClickAway: PropTypes.func,
  className: PropTypes.string
};

export default function ChatContactSearch({ query, onChange, onFocus, onClickAway, className = '' }) {
  const { t } = useTranslation('chat');
  return (
    <ClickAwayListener onClickAway={onClickAway}>
        <FormControl fullWidth size="small">
          <Input
            className={`h-8 ${className}`}
            value={query}
            onFocus={onFocus}
            onChange={onChange}
            placeholder={t('list.searchChatsPlaceholder', 'Pesquisar chats...')}
          />
        </FormControl>
    </ClickAwayListener>
  );
}
